import React, { useContext, useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Calendar, ArrowLeft, Share2,
  Facebook, Twitter, Linkedin, Link2,
  Tag, TrendingUp, ArrowRight
} from 'lucide-react';
import '../../../assets/css/screens/customer/blogs/BlogsDetail.css';
import Navbar from '../../../components/customer/home/Navbar/MyNavbar';
import Topbar from '../../../components/customer/home/topbar/Topbar';
import Footer from '../../../components/customer/home/footer/Myfooter';
import axios from 'axios';
import AppContext from '../../../context/AppContext';

const BlogsDetail = () => {
  const { baseUrl, baseUrlForFile } = useContext(AppContext);
  const { slug } = useParams();
  const navigate = useNavigate();

  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showShareMenu, setShowShareMenu] = useState(false);
const cleanHTML = (html) => {
  if (!html) return "";

  const txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
};
  /* ───────── API CALL ───────── */
  useEffect(() => {
    setLoading(true);

    axios.get(`${baseUrl}/user/blogdetail/${slug}`)
      .then(res => {
        if (res.data.success) {
          setBlog(res.data.blog);
        } else {
          setBlog(null);
        }
      })
      .catch(() => setBlog(null))
      .finally(() => setLoading(false));

  }, [slug, baseUrl]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  /* ───────── LOADING ───────── */
  if (loading) {
    return (
      <>
        <Topbar />
        <Navbar />
        <div style={{ padding: 20 }}>Loading...</div>
        <Footer />
      </>
    );
  }

  /* ───────── NOT FOUND ───────── */
  if (!blog) {
    return (
      <>
        <Topbar />
        <Navbar />
        <div className="blog-detail-error">
          <h2>Blog post not found</h2>
          <p>The blog you're looking for doesn't exist.</p>
          <button onClick={() => navigate('/blogs')}>
            <ArrowLeft size={18} /> Back to Blogs
          </button>
        </div>
        <Footer />
      </>
    );
  }

  /* ───────── SHARE ───────── */
  const handleShare = (platform) => {
    const url = window.location.href;
    const text = blog.blog_title;

    switch (platform) {
      case 'facebook':
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`, '_blank');
        break;

      case 'twitter':
        window.open(`https://twitter.com/intent/tweet?url=${url}&text=${text}`, '_blank');
        break;

      case 'linkedin':
        window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${url}`, '_blank');
        break;

      case 'copy':
        navigator.clipboard.writeText(url);
        alert('Link copied!');
        break;

      default:
        break;
    }

    setShowShareMenu(false);
  };

  return (
    <>
      <Topbar />
      <Navbar />

      <div className="blog-detail-page">

        {/* Back */}
        <div className="back-navigation">
          <button onClick={() => navigate('/blogs')} className="btn-back">
            <ArrowLeft size={18} /> Back to Blogs
          </button>
        </div>

        {/* Hero Image */}
        <div className="blog-hero-image">
          <img
            src={`${baseUrlForFile}/${blog?.image}`}
            alt={blog?.blog_title}
          />
        </div>

        <div className="blog-detail-container">
          <div className="blog-main-content">

            {/* Header */}
            <div className="article-header">
              <h1>{blog?.blog_title}</h1>

              <div className="article-meta">
                <div className="meta-left">
                  <span className="meta-item">
                    <Calendar size={16} />
                    {blog?.created_at}
                  </span>
                </div>

                {/* Share */}
                <div className="share-section">
                  <button
                    className="btn-share"
                    onClick={() => setShowShareMenu(!showShareMenu)}
                  >
                    <Share2 size={18} /> Share
                  </button>

                  {showShareMenu && (
                    <div className="share-menu">
                      <button onClick={() => handleShare('facebook')}>
                        <Facebook size={16} /> Facebook
                      </button>
                      <button onClick={() => handleShare('twitter')}>
                        <Twitter size={16} /> Twitter
                      </button>
                      <button onClick={() => handleShare('linkedin')}>
                        <Linkedin size={16} /> LinkedIn
                      </button>
                      <button onClick={() => handleShare('copy')}>
                        <Link2 size={16} /> Copy Link
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Content */}
          <div
  className="article-content"
  dangerouslySetInnerHTML={{
    __html: cleanHTML(blog?.description)
  }}
/>

            {/* Tags */}
            {blog?.keywords && (
              <div className="article-tags">
                <Tag size={18} />
                {blog.keywords.split(',').map((tag, i) => (
                  <span key={i} className="tag-item">
                    {tag.trim()}
                  </span>
                ))}
              </div>
            )}

          </div>

        
        </div>
      </div>

      <Footer />
    </>
  );
};

export default BlogsDetail;